import {
  filterByCode,
  generalGobernadorA1, 
  generalJefeGobiernoA1, 
  generalPresidenteA1, 
  balotajePresidenteA1,
  generateValidUrl, 
  gobernadorA1, 
  gobernadorA2, 
  gobernadorA3, 
  jefeGobiernoA1, 
  jefeGobiernoA2, 
  jefeGobiernoA3, 
  presidenteA1, 
  presidenteA2, 
  presidenteA3, 
  presidenteA1Balotaje, 
  getDateUpdateBalotaje,
  legislativasA1,
  legislativasA2,
  getBarriosByComuna
} from "@/helpers/getPostElection";
import { Service } from "models/Service";
import { imagePost } from "../../helpers/getPostElection";
import { mappings } from "./data";
import { getDateFormatForHead, getDateFormatZulu } from "@/helpers/formatDate";
import axios from "axios";
export class Elections extends Service {
  constructor() {
    super({
      adsPath: "politica/nota",
      meta: {
        description: `Elecciones - Clarin.com`,
        keywords: 'Elecciones, Presidenciales 2023, Presidente, Gobernador, Ganadores, Resultados, Comicios, Sergio Massa, Patricia Bullrich, Javier Milei, Axel kicillof, Néstor Grindetti, Carolina Píparo, Juntos por el cambio, La libertad avanza, Unión por la patria',
        title: `Elecciones - Clarin.com`,
        url: `elecciones`, 
        extra: [],
      },
      section: "politica",
      sectionName: "Elecciones",
      sectionAds: "politica",
      template: "Elections",
      title: `Elecciones`,
      widthFull: true,
      slug: "elecciones-clarin",
      titleHeader:"Elecciones",
      titleHeaderLink:"/elecciones",
      autorefresh : false
    });    
  }

  parseData = async (query, menu) => {
    const [basePath, year, electionType, electionCategory, resultPath] = query;
    const url = `${basePath}/${year}/${electionType}/${electionCategory}/${resultPath}`;
    const electionInstance = electionType  == 'balotaje' ? 'balotaje' : 'general';
    const typeElection = electionCategory;
    const parametros = resultPath.match(/([A-Z]{2}-[A-Z]\d{3})\.html/);
    let codeLetter, codeNumber, districts, content, urlIframe,endpoint,baseUrl,codeComplet,imgPostPri, titleMeta, descriptionMeta;
    const porcentaje = 5;
    const dateNow = new Date();
    if (typeElection == 'presidente') {
      baseUrl = `/elecciones/2023/${electionType}/presidente/resultados-`;
      endpoint = `president.json?rv=${dateNow.getHours()}${dateNow.getMinutes()}`;
    } else if (typeElection == 'legislativas') {
      baseUrl = `/elecciones/2025/generales/legislativas/resultados-ciudad-autonoma-bsas-`;
      endpoint = `legislative.json?rv=${dateNow.getHours()}${dateNow.getMinutes()}`;
    } else {
      baseUrl = "/elecciones/2023/generales/gobernador/resultados-";
      endpoint = `governors.json?rv=${dateNow.getHours()}${dateNow.getMinutes()}`;
    }

    if (parametros) {
      codeComplet = parametros[1]; // "AR-C001"
      const parametros2 = codeComplet.match(/^([A-Z]+-[A-Z]+)(\d+)$/);
      if (parametros2) {
        codeLetter = parametros2[1]; // "AR-C"
        codeNumber = parametros2[2]; // "001"
      } else {
        codeLetter = codeComplet;
        codeNumber = "";
      }
    }
    
    const obtenerURLImagen = (code) => {
      if (imagePost[code]) {
        return imagePost[code].url;
      } else {
        return null;
      }
    }
 
    // informacion para el sitemap
    const apiUrlPres = `http://data-ecp.clarin.com/clarin.com/2023/argentina/${electionInstance}/AR_president.json`;
    const provinciasPresidente = await this.fetchData(apiUrlPres);
    const apiUrlGov=`http://data-ecp.clarin.com/clarin.com/2023/argentina/${electionInstance}/${codeLetter}_governors.json`;
    //const provinciasGobernadorGeneral = await this.fetchData(apiUrlGov);
    let provincias = [];
    const distritosProvincia = [];
    const gobernadorSitemap = [];
    let infoPresidentOrGovernors = provinciasPresidente
    
    if (provinciasPresidente.data && Array.isArray(provinciasPresidente.data.districts) && provinciasPresidente.data.districts.length > 0) {      
      provinciasPresidente.data.districts.forEach((provincia) => {
        let url = generateValidUrl(baseUrl,provincia.name, "", provincia.code);
        
        const obj = {
          id: `presidente_${provincia.id}`,
          name: provincia.name,
          code: provincia.code,
          url: url,
          last_update: provincia.last_update,
          publication_date: "2023-10-11T07:00:00.000Z",
          title : `Elecciones 2023: Presidente en ${provincia.name}`
        };
        provincias.push(obj);
      });
    }
    
    //distirtos de la provincia
    await Promise.all(provincias.map(async (distrito) => {
      let apiUrlDist = `http://data-ecp.clarin.com/clarin.com/2023/argentina/${electionInstance}/${distrito.code}_governors.json`;
      const { code, data } = await this.fetchData(apiUrlDist);
      if (code === 200) {
        let dist = data?.districts
        if (Array.isArray(dist) && dist.length > 0) {
          dist.forEach((element) => {
            let url = generateValidUrl(baseUrl, element.name, "", element.code);
            
            const obj = {
              id: `distritosProvincia_${element.id}`,
              name: element.name,
              code: element.code,
              url: url,
              last_update: element.last_update,
              publication_date: "2023-10-11T07:00:00.000Z",
              title : `Elecciones 2023: Presidente en ${element.name}`
            };
            distritosProvincia.push(obj);
          });
        }
      }
    }));

    const provinciaGobernadores = ['AR-C', 'AR-K', 'AR-B',];
    const provinciasGobernador = provincias.filter((provincia) => {
      return provinciaGobernadores.includes(provincia.code);
    });
    
    // 5 - 25% mostrar alternativa 1
    // 25 - 50% mostrar alternativa 2
    // 50 - adelante alternativa 3
    const crearPost = (data, typeElection, urlIframe = "", porcentajeMesasEscutradas, modified_time) => {
      const votosEnBlanco = data?.stats ? data?.stats.filter(item => item.type === "blank") : [];
      const votosImpugnados = data?.stats ? data?.stats.filter(item => item.type === "contested") : [];
      const votosNulos = data?.stats ? data?.stats.filter(item => item.type === "annulled") : [];
      let post;
      
      const getPostByElectionType = (type) => {
        switch (type) {
          case "presidente":
            if(electionType == "balotaje") {
              return {
                a1: presidenteA1Balotaje,
                a2: presidenteA1Balotaje,
                a3: presidenteA1Balotaje,
              };
            }
            return {
              a1: presidenteA1,
              a2: presidenteA2,
              a3: presidenteA3,
            };
          case "gobernador":
            return {
              a1: gobernadorA1,
              a2: gobernadorA2,
              a3: gobernadorA3,
            };
          case "jefeGobierno":
            return {
              a1: jefeGobiernoA1,
              a2: jefeGobiernoA2,
              a3: jefeGobiernoA3,
            };
          case "balotaje":
            return {
              a1: balotajePresidenteA1,
            }
          case "general":
          case "generalGobernadorA1":
          case "generalJefeGobiernoA1":
            return {
              a1: generalPresidenteA1,
              a2: generalGobernadorA1,
              a3: generalJefeGobiernoA1,
            };
          case "legislativasA1":
            return {
              a1: legislativasA1,
              a2: legislativasA2,
              a3: legislativasA2,
            };
          default:
            return null;
        }
      };
      const electionTypeFunctions = getPostByElectionType(typeElection);

      if (electionTypeFunctions) {
        let postFunction;
        if (porcentajeMesasEscutradas >= 5 && porcentajeMesasEscutradas <= 25) {
          postFunction = electionTypeFunctions.a1;
        } else if (porcentajeMesasEscutradas > 25 && porcentajeMesasEscutradas <= 50) {
          postFunction = electionTypeFunctions.a2;
        } else if (porcentajeMesasEscutradas > 50) {
          postFunction = electionTypeFunctions.a3;
        } else if (porcentajeMesasEscutradas <= 5 && typeElection == "general") {
          postFunction = electionTypeFunctions.a1;
        } else if (porcentajeMesasEscutradas <= 5 && typeElection == "generalGobernadorA1") {
          postFunction = electionTypeFunctions.a2;
        } else if (porcentajeMesasEscutradas <= 5 && typeElection == "generalJefeGobiernoA1") {
          postFunction = electionTypeFunctions.a3;
        } else if (porcentajeMesasEscutradas <= 5 && typeElection == "balotaje") {
          postFunction = electionTypeFunctions.a1;
        } else if (porcentajeMesasEscutradas <= 0 && typeElection == "legislativasA1") {
          postFunction = electionTypeFunctions.a1;
        }else if (porcentajeMesasEscutradas >= 1 && typeElection == "legislativasA1") {
          postFunction = electionTypeFunctions.a2;
        }
        if (postFunction) {
          post = postFunction(data, votosEnBlanco, votosImpugnados, votosNulos, urlIframe, infoPresidentOrGovernors, codeLetter, codeNumber, modified_time, menu);
        }
      }
      return post;
    };
    
    const baseIframeUrl = `https://ecp.clarin.com/2023/${electionInstance}/index.html#/map`;
    const mapType = typeElection === "presidente" ? "president" : "governors";
    const locationPath = codeLetter && codeNumber ? `${codeLetter}/${codeLetter}${codeNumber}` : `${codeLetter}/_`;

    urlIframe = `${baseIframeUrl}/${mapType}/${locationPath}`;

    async function generarDatosElecciones({codeLetter,codeNumber,codeComplet,mappings,typeElection,url,baseUrl,crearPost,generateValidUrl}) {
      const selectedProvince = mappings.provinces;
      const selectedDistricts = mappings.districts;
    
      const filteredProvinceNames = Object.values(selectedProvince).filter(p => p.code === codeLetter);
      const filteredDistricts = selectedDistricts[filteredProvinceNames[0]?.id] || [];
      const filteredDistrictNames = filteredDistricts.find(d => d.code === codeComplet);
    
      const dataPost = {
        last_update: new Date(),
        provincia: filteredProvinceNames[0]?.name || "Argentina",
        provinciaLocalidad: typeElection === 'legislativas'
          ? filteredDistrictNames?.name || "Argentina"
          : (codeNumber
              ? `${filteredProvinceNames[0]?.name} - ${filteredDistrictNames?.name}`
              : filteredProvinceNames[0]?.name || "Argentina"),
        localidad: filteredDistrictNames?.name || "",
      };
    
      let tags = []

      let content;
      if (typeElection === "presidente") {
        content = crearPost(dataPost, "general", "", 0, "");
      } else {
        if (codeLetter === "AR-C" && typeElection !== "legislativas") {
          content = crearPost(dataPost, "generalJefeGobiernoA1", "", 0, "");
        } else if (codeLetter === "AR-C" && typeElection == "legislativas") {
          tags = [
            { name: "Elecciones 2025", slug: "elecciones-2025", subject: "subject", _id: "4JzQK5otxx" },
            { name: "Ciudad de Buenos Aires", slug: "ciudad-de-buenos-aires", subject: "subject", _id: "EJcOBdLDg" }
          ];
          content = crearPost(dataPost, "legislativasA1", "", 0, "");
        } else {
          content = crearPost(dataPost, "generalGobernadorA1", "", 0, "");
        }
      }
    
      const provinciaGobernadoresIds = ['01', '02', '03', '08'];
      const responseGob = provinciaGobernadoresIds.map(id => selectedProvince[id]);
    
      const provincias = Object.values(selectedProvince).map(item => ({
        id: `presidente_${item.id}`,
        name: item.name,
        code: item.code,
        url: `/elecciones/2023/generales/presidente/resultados-${item.name.toLowerCase().replace(/\s/g, '-')}_8_${item.code}.html`,
        last_update: 1696678200000,
        publication_date: '2023-10-11T07:00:00.000Z',
        title: `Elecciones 2023: Presidente en ${item.name}`
      }));
    
      const provinciasGob = responseGob.map(item => ({
        id: `presidente_${item.id}`,
        name: item.name,
        code: item.code,
        url: `/elecciones/2023/generales/gobernador/resultados-${item.name.toLowerCase().replace(/\s/g, '-')}_8_${item.code}.html`,
        last_update: 1696678200000,
        publication_date: '2023-10-11T07:00:00.000Z',
        title: `Elecciones 2023: Presidente en ${item.name}`
      }));
    
      const verificacionGob = responseGob.find(prov => prov.code === codeLetter);
      const verificacionPre = provincias.find(prov => prov.code === codeLetter);
    
      const verificar = (
        (verificacionPre && typeElection === "presidente") ||
        (verificacionGob && typeElection !== "presidente")
      );
    
      if (!verificar) {
        return { code: 404 };
      }
    
      const districtsWithUrls = filteredDistricts.map(district => {
        const districtSlug = district.name
            .toLowerCase()
            .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            .replace(/[^a-z0-9\s-]/g, "")
            .trim()
            .replace(/\s+/g, "-");
        const urlNota = typeElection !== "legislativas"
          ? generateValidUrl(district.name, baseUrl, filteredProvinceNames[0]?.name, district.code)
          : `${baseUrl}${districtSlug}_8_${district.code}.html`;

        return {
          ...district,
          url: urlNota
        };
      });
      const codeLetters = ["AR-CL1", "AR-CL2"];
      const randomCodeLetter = codeLetters[Math.floor(Math.random() * codeLetters.length)];

      const imgPostPri = obtenerURLImagen(randomCodeLetter);
      const related = {
        "images": [
          {
            "epigraphe": "Los porteños van a las urnas para elegir legisladores. Crédito: Clarín/ imagen retocada con IA",
            "type": "image",
            "value": {
              "entityId": "136922_1",
              "author": "REUTER",
              "title": "Los porteños van a las urnas para elegir legisladores. Crédito: Clarín/ imagen retocada con IA",
              "clippings": [
                {
                  "url": `${imgPostPri}`,
                  "_id": "Apertura_full",
                  "dimensions": {
                    "width": 1256,
                    "height": 620
                  }
                },
                {
                  "url": `${imgPostPri}`,
                  "_id": "col_listado_1x1",
                  "dimensions": {
                    "width": 340,
                    "height": 340
                  }
                },
              ]
            },
            "_id": "_uwmU9FBY"
          }
        ],
        "datafactory": [],
        "mams": []
      }
    
      return {
        data: [],
        url: url,
        content: content ?? [],
        districts: districtsWithUrls ?? [],
        provincias: typeElection === "presidente" ? provincias : provinciasGob ?? [],
        textSeparador: `Mirá los resultados en las demás distritos de la Ciudad Autónoma Bs.As. ${filteredProvinceNames[0]?.name}`,
        textSeparadorProvincias: `Mirá los resultados en las demás Provincias de Argentina`,
        imgPostPri: "https://www.clarin.com/img/2023/10/06/OHw4KnSeM_1256x620__1.jpg",
        related,
        tags,
        meta: {
          description: "Elecciones 2023",
          title: "Elecciones 2023",
          url: url,
          extra: [
            { name: "title", content: "Elecciones 2023" },
            { name: "distribution", content: "global" },
            { name: "robots", content: "max-image-preview:large" },
            { property: "article:published_time", content: "2023-10-22T19:05:00.000Z" },
            { property: "article:modified_time", content: "2023-10-22T19:05:00.000Z" },
          ]
        },
        title: typeElection === "presidente" ? "Elecciones presidente 2023" : "Elecciones Gobernador 2023"
      };
    }

    async function datosPresidenciales({ data, query, codeLetter, codeNumber, codeComplet, urlIframe, baseUrl, porcentaje, provincias, provinciasGobernador, distritosProvincia, gobernadorSitemap, typeElection }) {
      const nameProvincia = data?.name === "Resultados Nacionales" ? "Argentina" : data?.name;
      const percentagesScrutinized = data?.tables_percent;
      const imgPostPri = obtenerURLImagen(codeLetter);
      const districts = data?.districts.find(item => item.code === codeComplet);
    
      data?.districts?.forEach(district => {
        district.url = generateValidUrl(baseUrl, nameProvincia, district.name, district.code);
      });
    
      const tags = [
        { name: "Elecciones 2023", slug: "elecciones-2023", subject: "subject", _id: "VyFmuMo-2" }
      ];
    
      let modified_time = "";
      let keywords = "";
    
      if (electionType === "balotaje") {
        modified_time = await getDateUpdateBalotaje(data?.last_update);
        keywords = `${nameProvincia}, Balotaje, Elecciones 2023, Presidenciales 2023, Presidente, Ganadores, Resultados, Comicios, Fórmula Ganadora, Sergio Massa, Javier Milei, La Libertad Avanza, Unión por la Patria, Victoria Villarruel, Agustín Rossi`;
        tags.push(
          { name: "Sergio Massa", slug: "sergio-massa" },
          { name: "Javier Milei", slug: "javier-milei" },
          { name: "Unión por la Patria", slug: "union-por-la-patria" },
          { name: "La Libertad Avanza", slug: "la-libertad-avanza" },
          { name: "Balotaje", slug: "balotaje" }
        );
      } else {
        modified_time = (!!data && data?.tables_percent && data.tables_percent > 0) ? getDateFormatZulu(data?.last_update) : "2023-10-22T19:05:00.000Z";
        keywords = 'Elecciones, Presidenciales 2023, Presidente, Gobernador, Ganadores, Resultados, Comicios, Sergio Massa, Patricia Bullrich, Javier Milei, Axel kicillof, Néstor Grindetti, Carolina Píparo, Juntos por el cambio, La libertad avanza, Unión por la patria';
      }
    
      const dataPost = {
        last_update: modified_time,
        mesasEscrutadas: codeNumber ? districts?.tables_percent : data.tables_percent,
        provincia: nameProvincia,
        localidad: districts?.name || "",
        provinciaLocalidad: codeNumber ? `${nameProvincia}, ${districts?.name}` : nameProvincia,
        candidatos: data?.parties || [],
        stats: codeNumber ? districts?.stats : data?.stats,
        ganador: codeNumber ? districts?.parties[0] : data.parties[0],
        segundo: codeNumber ? districts?.parties[1] : data.parties[1],
        tercero: codeNumber ? districts?.parties[2] : data.parties[2],
        cuarto: codeNumber ? districts?.parties[3] : data.parties[3],
        quinto: codeNumber ? districts?.parties[4] : data.parties[4],
      };
    
      const instanceElection = electionType === "generales" ? "general" : "balotaje";
      let content = null;
    
      const percentActual = codeNumber ? districts?.tables_percent : percentagesScrutinized;
    
      if (typeElection === "presidente") {
        const instance = percentActual < porcentaje ? instanceElection : typeElection;
        content = crearPost(dataPost, instance, urlIframe, percentActual, modified_time);
      } else if (typeElection !== "presidente") {
        const isCABA = codeLetter === "AR-C";
        const general = percentActual < porcentaje;
        const instance = isCABA
          ? (general ? "generalJefeGobiernoA1" : "jefeGobierno")
          : (general ? "generalGobernadorA1" : "gobernador");
    
        content = crearPost(dataPost, instance, urlIframe, percentActual);
      }
    
      const titleMeta = content?.title ?? "";
      const descriptionMeta = (content?.description || content?.body?.[0]?.value.replace(/<[^>]*>/g, '')?.trim()) ?? "Elecciones Argentina 2023";
    
      return {
        _id: `${codeLetter}${codeNumber}`,
        content: content ?? [],
        url: baseUrl,
        data,
        districts: query[4] === "resultados-elecciones-argentina_8_AR.html" ? [] : data?.districts ?? [],
        provincias: typeElection === "presidente" ? provincias : provinciasGobernador ?? [],
        distritosProvincia: distritosProvincia ?? [],
        gobernadorSitemap: gobernadorSitemap ?? [],
        textSeparador: `Mirá los resultados en los demás distritos de ${nameProvincia}`,
        textSeparadorProvincias: `Mirá los resultados en las demás provincias de Argentina`,
        imgPostPri: imgPostPri ?? "https://www.clarin.com/img/2023/10/06/OHw4KnSeM_1256x620__1.jpg",
        tags,
        meta: {
          description: descriptionMeta,
          title: titleMeta,
          keywords,
          url: baseUrl,
          urlImage: imgPostPri,
          extra: [
            { name: "title", content: titleMeta },
            { name: "distribution", content: "global" },
            { name: "robots", content: "max-image-preview:large" },
            { property: "article:published_time", content: electionType === "balotaje" ? "2023-11-19T13:00:00.000Z" : "2023-10-22T19:05:00.000Z" },
            { property: "article:modified_time", content: modified_time }
          ]
        }
      };
    }

    async function datosLegislativas({ data, query, codeLetter, codeNumber, codeComplet, urlIframe, baseUrl, porcentaje, provincias, provinciasGobernador, distritosProvincia, gobernadorSitemap, typeElection }) {
      const nameProvincia = data?.name;
      const percentagesScrutinized = data?.tables_percent;
      const selectedDistricts = mappings.districts;
      const filteredDistricts = selectedDistricts['01'] || [];

      const codeLetters = ["AR-CL1", "AR-CL2"];
      const randomCodeLetter = codeLetters[Math.floor(Math.random() * codeLetters.length)];

      const imgPostPri = obtenerURLImagen(randomCodeLetter);
      const related = {
        "images": [
          {
            "epigraphe": "Los porteños van a las urnas para elegir legisladores. Crédito: Clarín/ imagen retocada con IA",
            "type": "image",
            "value": {
              "entityId": "136922_1",
              "author": "REUTER",
              "title": "Los porteños van a las urnas para elegir legisladores. Crédito: Clarín/ imagen retocada con IA",
              "clippings": [
                {
                  "url": `${imgPostPri}`,
                  "_id": "Apertura_full",
                  "dimensions": {
                    "width": 1256,
                    "height": 620
                  }
                },
                {
                  "url": `${imgPostPri}`,
                  "_id": "col_listado_1x1",
                  "dimensions": {
                    "width": 340,
                    "height": 340
                  }
                },
              ]
            },
            "_id": "_uwmU9FBY"
          }
        ],
        "datafactory": [],
        "mams": []
      }
      const selectedDistrict = data?.districts?.find(item => item.code === codeComplet);

      data?.districts?.forEach(district => {
        district.url = generateValidUrl(baseUrl, nameProvincia, district.name, district.code);
      });

      const districtsWithUrls = filteredDistricts.map(district => {
        const districtSlug = district.name
            .toLowerCase()
            .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            .replace(/[^a-z0-9\s-]/g, "")
            .trim()
            .replace(/\s+/g, "-");
        const urlNota = typeElection !== "legislativas"
          ? generateValidUrl(district.name, baseUrl, filteredProvinceNames[0]?.name, district.code)
          : `${baseUrl}${districtSlug}_8_${district.code}.html`;

        return {
          ...district,
          url: urlNota
        };
      });
      const tags = [
        { name: "Elecciones 2025", slug: "elecciones-2025", subject: "subject", _id: "4JzQK5otxx" },
        { name: "Ciudad de Buenos Aires", slug: "ciudad-de-buenos-aires", subject: "subject", _id: "EJcOBdLDg" }
      ];

      let modified_time = "";
      let keywords = "Legislatura porteña, Boleta única, Votación, Candidatos, Escrutinio, Resultados, Comicios";

      modified_time = (!!data && data?.tables_percent && data.tables_percent > 0)
        ? getDateFormatZulu(data?.last_update)
        : `${year}-10-22T19:05:00.000Z`;

      const dataPost = {
        last_update: modified_time,
        mesasEscrutadas: codeNumber ? selectedDistrict?.tables_percent : data?.tables_percent,
        provincia: nameProvincia,
        localidad: selectedDistrict?.name || "",
        provinciaLocalidad: codeNumber ? `${selectedDistrict?.name}` : nameProvincia,
        candidatos: selectedDistrict?.parties || [],
        stats: codeNumber ? selectedDistrict?.stats : data?.stats,
        ganador: codeNumber ? selectedDistrict?.parties?.[0] : data?.parties?.[0],
        segundo: codeNumber ? selectedDistrict?.parties?.[1] : data?.parties?.[1],
        tercero: codeNumber ? selectedDistrict?.parties?.[2] : data?.parties?.[2],
        cuarto: codeNumber ? selectedDistrict?.parties?.[3] : data?.parties?.[3],
        quinto: codeNumber ? selectedDistrict?.parties?.[4] : data?.parties?.[4],
        barrios: getBarriosByComuna(codeNumber) || [],
      };
    
      let content = null;
    
      const percentActual = codeNumber ? selectedDistrict?.tables_percent : percentagesScrutinized;
      content = crearPost(dataPost, 'legislativasA1', urlIframe, percentActual, modified_time);
      const titleMeta = content?.title ?? "";
      const descriptionMeta = (content?.description || content?.body?.[0]?.value.replace(/<[^>]*>/g, '')?.trim()) ?? "Elecciones Legislativas 2023";

      // content.related = related;
      // content.tags = tags;
      
      return {
        _id: `${codeLetter}${codeNumber}`,
        content: content ?? [],
        url: baseUrl,
        data,
        districts: districtsWithUrls ?? [],
        provincias: null, // si aplica
        distritosProvincia: [], // si aplica
        gobernadorSitemap: [], // si aplica
        textSeparador: `Mirá los resultados en los demás distritos de ${nameProvincia}`,
        textSeparadorProvincias: `Mirá los resultados en las demás provincias de Argentina`,
        imgPostPri: imgPostPri,
        tags,
        related,
        meta: {
          description: descriptionMeta,
          title: titleMeta,
          keywords,
          url: baseUrl,
          urlImage: imgPostPri,
          extra: [
            { name: "title", content: titleMeta },
            { name: "distribution", content: "global" },
            { name: "robots", content: "max-image-preview:large" },
            { property: "article:published_time", content: electionType === "balotaje" ? `${year}-11-19T13:00:00.000Z` : `${year}-10-22T19:05:00.000Z` },
            { property: "article:modified_time", content: modified_time }
          ]
        }
      };
    }
    
    let apiUrl;
    if(typeElection == "legislativas"){
      apiUrl = `https://data-ecp.clarin.com/clarin.com/2025/argentina/general/AR-C_delegatesprov.json`;
      // apiUrl = "https://staging-data-ecp.clarin.com/clarin.com/2025/argentina/api-automatic/general/AR-C_delegatesprov.json"
    }else{
      apiUrl = `http://data-ecp.clarin.com/clarin.com/${year}/argentina/${electionInstance}/${codeLetter}_${endpoint}`;
    }
    let response;
    let data = null;
    let code = 500;
    let error = null;

    try {
      response = await axios({
        method: 'get',
        url: apiUrl,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        }
      });

      code = response.status;
      data = response.data;
      console.log("API ELECTIONS: ", apiUrl, code, data);
    } catch (err) {
      error = err.message;
      console.error("Error en la request:", error);
      if (err.response) {
        code = err.response.status;
        data = err.response.data;
        console.error("Status:", code);
        console.error("Body:", data);
      }
    }
    if (code == 200) {
      const selectedDistrict = data?.districts?.find(item => item.code === codeComplet);
      let datos;

      if (typeElection !== "legislativas") {
        datos = await datosPresidenciales({
          data, query, codeLetter, codeNumber, codeComplet,
          urlIframe, baseUrl, porcentaje, provincias,
          provinciasGobernador, distritosProvincia,
          gobernadorSitemap, typeElection
        });

        this.setData(datos);
        this.setTitle(datos?.post?.title || `Resultado Elecciones ${year}`);
        this.setTitleHeader("Elecciones");
        this.setMeta(this.parseMeta(datos.meta));

      } else if (selectedDistrict && typeElection === "legislativas") {
        datos = await datosLegislativas({
          data, query, codeLetter, codeNumber, codeComplet,
          urlIframe, baseUrl, porcentaje, provincias,
          provinciasGobernador, distritosProvincia,
          gobernadorSitemap, typeElection
        });
        this.setData(datos);
        this.setTitle(datos?.post?.title || `Resultado Elecciones ${year}`);
        this.setTitleHeader("Elecciones");
        this.setMeta(this.parseMeta(datos.meta));

      } else {
        const resultado = await generarDatosElecciones({codeLetter,codeNumber,codeComplet,mappings,typeElection,url,baseUrl,crearPost,generateValidUrl});
        if (resultado.code === 404) {
          this.setData({ code: 404 });
        } else {
          this.setData(resultado);
          this.setTitle(`Elecciones Legislativas ${year}`);
          this.setTitleHeader(`Elecciones Legislativas ${year}`);
          this.setMeta(this.parseMeta({
            description: `Elecciones ${year}`,
            title: `Elecciones ${year}`,
            url: this.url,
            extra: [
              { name: "title", content: `Elecciones ${year}` },
              { name: "distribution", content: "global" },
              { name: "robots", content: "max-image-preview:large" },
              { property: "article:published_time", content: `${year}-10-22T19:05:00.000Z` },
              { property: "article:modified_time", content: `${year}-10-22T19:05:00.000Z` },
            ]
          }));
        }
      }

    } else {
      const resultado = await generarDatosElecciones({codeLetter,codeNumber,codeComplet,mappings,typeElection,url,baseUrl,crearPost,generateValidUrl});
      if (resultado.code === 404) {
        this.setData({ code: 404 });
      } else {
        this.setData(resultado);
        this.setTitle('Elecciones Legislativas 2025');
        this.setTitleHeader('Elecciones Legislativas 2025');
        this.setMeta(this.parseMeta({
          description: "Elecciones 2023",
          title: "Elecciones 2023",
          url: this.url,
          extra: [
            { name: "title", content: "Elecciones 2023" },
            { name: "distribution", content: "global" },
            { name: "robots", content: "max-image-preview:large" },
            { property: "article:published_time", content: "2023-10-22T19:05:00.000Z" },
            { property: "article:modified_time", content: "2023-10-22T19:05:00.000Z" },
          ]
        }));
      }
    }
  }
}